import React, { forwardRef, useMemo } from 'react'
import { FieldTypes } from 'utils/formUtils';
import GenericPullCredentialsForm from '../GenericPullCredentialsForm';
import BugCrowdMappingForm from './BugCrowdMappingForm';

function BugCrowdCredentialsForm(props, ref){
    const fields = useMemo(() => [{
        name: "token",
        label: "Token",
        type: FieldTypes.PASSWORD,
        required: true,
    }], [])
    
    return (
        <GenericPullCredentialsForm
            {...props}
            ref={ref}
            fields={fields}
            MappingForm={BugCrowdMappingForm}
        />
    )
}

export default forwardRef(BugCrowdCredentialsForm);